import React from 'react';
import {Modal} from "react-bootstrap";
import {useDispatch, useSelector} from "react-redux";
import {closeDeleteModalInst, deleteInstruction} from "../../redux-store/triggers";
import {deleteItemInstConfirmation, idMOdal} from "../../redux-store/selectors";

const ConfirmationDeleteInstruction = ({installationId,eventKey}) => {
    const modalDeleteStatus = useSelector(deleteItemInstConfirmation)
    const idModalDelete = useSelector(idMOdal)

    const dispatch = useDispatch();

    const handleCloseModal = () => {
        dispatch(closeDeleteModalInst())
    }

    const handleDeleteItem = () => {
        dispatch(deleteInstruction({installationId:installationId, triggerItemId:eventKey, idForDelete:idModalDelete}))
        dispatch(closeDeleteModalInst())
    }

    return (
        <Modal
            show={modalDeleteStatus}
            onHide={handleCloseModal}
            backdrop="static"
            keyboard={false}
        >
            <Modal.Header closeButton className={"modal-header-component text-center"}>
                <Modal.Title className={"title-confirm"}>Potvrda brisanja</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className={"mb-5 text-left"}>
                    <h5>Da li ste sigurni da želite obrisati ovu instrukciju?</h5>
                </div>
                <div className={"modal-footer-component text-right"}>
                    <button className={"btn btn-modal-cancel"} onClick={handleCloseModal}>
                        Odustani
                    </button>
                    <button className={"btn btn-modal-confirm-delete"} onClick={handleDeleteItem}>Obriši</button>
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default ConfirmationDeleteInstruction;
